import React, { startTransition, useState } from 'react'
import type { TeamStanding } from '../../Api'
import { Season } from '../../Context/SeasonContext/SeasonContext'
import { RoundedTabs } from '../Tab/styles'
import { StandingsSection } from './StandingsSection'
import { StandingsTypeCon } from './styles'
import { logEvent } from '../../Utils'
import { ANALYTICS_TAGS } from '../../Constants/analytics'
import { Tab } from '../LazyComponents'

type HeaderProps = {
  items: TeamStanding[]
  seasonSelect: Season
  full?: boolean
  section?: string
  theme?: 'light' | 'dark'
}

export const StandingsOuter: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  items,
  seasonSelect,
  full = false,
  section = 'standings',
  theme = 'light',
}) => {
  const standingsToggleOptions = ['Conference', 'Overall']
  const [standingsTabValue, setStandingsTabValue] = useState<number>(0)

  const handleStandingsChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    startTransition(() => {
      setStandingsTabValue(newValue)
      logEvent(ANALYTICS_TAGS.standings_toggle_click, {
        segment: newValue,
        segment_index: newValue,
        title: newValue === 0 ? 'Conference' : 'Overall',
      })
    })
  }
  const showTabs = seasonSelect.year >= 2024 && seasonSelect.seasonType === 'regular'

  return (
    <>
      {showTabs && (
        <>
          <StandingsTypeCon>
            <RoundedTabs
              value={standingsTabValue}
              onChange={handleStandingsChange}
              aria-label="league standings toggle"
              variant="fullWidth"
            >
              {standingsToggleOptions.map((t) => (
                <Tab label={t} key={t} />
              ))}
            </RoundedTabs>
          </StandingsTypeCon>
          <StandingsSection
            items={items}
            seasonSelect={seasonSelect}
            full={full}
            showLeagueStandings={standingsTabValue === 1}
            section={section}
            theme={theme}
          />
        </>
      )}

      {!showTabs && (
        <StandingsSection
          items={items}
          seasonSelect={seasonSelect}
          full={full}
          showLeagueStandings={false}
          section={section}
          theme={theme}
        />
      )}
    </>
  )
}
